import {validateMaxLength} from '../../../common/validationUtils';
import {messages} from '../../common/Translations';
import {plainJSTranslator} from "../../../common/PlainJSTranslator";


export const validateParkMachine = values => {
    let errors = {};
    const LENGTH = 100;

    if (!values.brand) {
        errors.brand = plainJSTranslator.formatMessage(messages.required);
    }
    if (!values.model) {
        errors.model = plainJSTranslator.formatMessage(messages.required);
    }

    if (!values.quantity) {
        errors.quantity = plainJSTranslator.formatMessage(messages.required);
    } else {
        let x = parseInt(values.quantity.toString());
        if (isNaN(x) || (x < 1)) {
            errors.quantity = 'Antal skal være et heltal større end 0';
        }
    }

    if (!values.categoryId) {
        errors.categoryId = 'Kategori kan ikke være blank';
    }

    return errors;
};


// WEBPACK FOOTER //
// ./web/src/components/park-machine/park-machine/validateParkMachine.js